/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NatureFxLightningBIcon20Regular = forwardRef('NatureFxLightningBIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.027 1.364C10.666.529 12 .981 12 2.033V8h3.891a1.1 1.1 0 0 1 .873 1.769l-6.79 8.867c-.64.835-1.974.383-1.974-.668V12H4.109a1.1 1.1 0 0 1-.873-1.769l6.79-8.867Zm.473 1.849L4.92 10.5H8.4a1.1 1.1 0 0 1 1.1 1.1v5.187L15.08 9.5H11.6a1.1 1.1 0 0 1-1.1-1.1V3.213Z" })));
});
